<template>
  <SelectWithSearch
    label="Serviço"
    placeholder="Pesquise um serviço"
    v-model="input"
    :filterBy="descriptionFilter"
    :disabled="disabled"
    :change="change"
    :options="serviceCollection"
    :search="search"
  >
    <template slot="no-options">Nenhum serviço encontrado</template>
    <template slot="options" slot-scope="props">
      <div class="selected" style="text-transform: uppercase">
        {{ props.data.description }} <br />
        R$: {{ valorReal(props.data.price) }}
      </div>
    </template>
    <template slot="selected" slot-scope="props">
      <div class="selected" style="text-transform: uppercase">
        {{ props.data.description }}
      </div>
    </template>
  </SelectWithSearch>
</template>

<script>
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import SearchMixin from '@/core/mixins/SearchMixin';

export default {
  name: 'SelectService',
  mixins: [FormatMixin, SearchMixin],
  components: {
    SelectWithSearch,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {},
  },
  data() {
    return {
      input: null,
    };
  },
  async mounted() {
    await this.setServiceCollection();
  },
  computed: {
    ...mapState('service', ['serviceCollection']),
  },
  methods: {
    ...mapActions('service', ['setServiceCollection']),

    async search(search) {
      await this.setServiceCollection(search);
    },
    change(value) {
      if (!value) {
        this.$emit('input', null);
        return;
      }

      const service = { ...value, quantity: 1, totalPrice: 0, discountType: 0 };

      this.$emit('input', service);
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
